import React from 'react'
import { connect } from 'react-redux'
import LoginForm from '../../components/login_form'
import SiteContainer from '../../components/layout/SiteContainer'
import { signOut } from '../../actions/AuthActions'
import HelmetTitle from '../../components/layout/HelmetTitle'

class Login extends React.Component {

  componentDidMount() {
    this.props.dispatch(signOut())
  }

  renderBody = (props,state) => <SiteContainer isSignedIn={props.apiAuth.isSignedIn}>
    <HelmetTitle title={'Login'} />
    <LoginForm apiAuth={props.apiAuth} dispatch={props.dispatch} />
  </SiteContainer>

  render = () => this.renderBody(this.props,this.state)

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
  }),
)(Login)



// WEBPACK FOOTER //
// ./src/containers/login/index.js